import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';

@Component({
  selector: 'app-btn-call-to-action',
  templateUrl: './btn-call-to-action.component.html',
  styleUrls: ['./btn-call-to-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BtnCallToActionComponent implements OnInit {
  @Input('size') size: 'sm' | 'md' | 'lg' = 'sm';
  @Input('fullWidth') fullWidth = false;
  @Input('color') color: 'orange' | 'green' = 'orange';
  @Input('icon') icon: 'arrow' | 'search' | 'send' = 'arrow';
  @Input('disabled') disabled = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
